var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"btn--kakao",class:[..._vm.classes],attrs:{"depressed":"","block":"","height":_vm.height},on:{"click":_vm.kakao}},[_vm._v(" 카카오 로그인 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }